// -*-mode: rjsx -*-
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
// eslint-disable-next-line
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableContainer from "@material-ui/core/TableContainer"
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// eslint-disable-next-line
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import grey from "@material-ui/core/colors/grey"

// eslint-disable-next-line
//import * as _ from "lodash"


// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<DashGeoFilter>")


function desc(a, b, orderBy) {
    // log.trace(`desc(): a=${a},b=${b},orderBy=${orderBy}`)
    
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


function EnhancedTableHead(props) {
    const { classes,
            // eslint-disable-next-line            
            onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort,
            txtName, showPlace } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    const headCells = [
    { id: 'column1', numeric: false, disablePadding: showPlace, label: txtName }
    ]

    
    return (
        <TableHead>
          <TableRow style={{
                        backgroundColor: "#438CFF",
          }}>
            { showPlace &&
            <TableCell padding="checkbox">
               <div style={{
                   textAlign: "center",
                   color: "white",
                   fontSize: 19,
               }}>#</div>
            </TableCell>
            }
            {headCells.map(headCell => (
                <TableCell
                  classes={{
                      stickyHeader: classes.tableCellStickyHeader // this makes the actuall header color
                  }}
                  key={headCell.id}
                  align={headCell.numeric ? 'right' : headCell.chart ? 'center' : 'left'}
                  padding={headCell.disablePadding ? 'none' : 'default'}
                  sortDirection={orderBy === headCell.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={order}
                    onClick={createSortHandler(headCell.id)}
                    classes={{
                        root: classes.headLabelRoot,
                        icon: classes.headLabelIcon,
                    }}
                // style={{color: "grey"}}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
            ))}
          </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
    theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
    : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
    },

    header1: {
        // flex: '1 1 100%',
        // backgroundColor: "grey"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        fontWeight: "600",
    },

    header2: {
        // flex: '1 1 100%',
        // backgroundColor: "black"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        color: "#65676b"
    },

    headersWrapper: {
        flex: '1 1 100%'
    }
    
}));


function EnhancedTableToolbar(props) {
    const classes = useToolbarStyles();
    const { header1, header2, numSelected } = props;

    return (
        <Toolbar
          className={clsx(classes.root, {
              [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
              <Typography className={classes.title} color="inherit" variant="subtitle1">
                {numSelected} selected
              </Typography>
          ) : (
              <div className={classes.headersWrapper}>
                <Typography className={classes.header1} variant="h6" id="tableHeader1">
                  {header1}
                </Typography>
                <Typography className={classes.header2} variant="h6" id="tableHeader2">
                  {header2}
                </Typography>
              </div>
          )}

          {numSelected > 0 ? (
              <Tooltip title="Delete">
                <IconButton aria-label="delete">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
          ) : (
              <Tooltip title="Filter list">
                <IconButton aria-label="filter list">
                  {/*
                     <FilterListIcon />
                   */}
                </IconButton>
              </Tooltip>
          )}
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        marginTop: theme.spacing(2),
    },
    paper: {
        width: '100%',
        height: '100%',
        minHeight: 300,
        maxHeight: 500,
        paddingBottom: 64, // compensate for the header
        marginBottom: theme.spacing(2),
        borderRadius: "8px"
    },
    table: {
        minWidth: 75,
        height: "100%",
//        maxWidth: 60,
//        maxHeight: 60,
        //        overflowY: "hidden"
    },
    tableWrapper: {
        // scroll
        // hidden
        // auto
        // visible
        // overflowX: 'auto', // hides within the left and top
        // overflowX: "scroll" // hidden with the scrollbar
        // overflowX: "scroll" // hidden with the scrollbar
        // overflowY: "scroll"
        // overflowX: "hidden" // hidden behind
        overflowX: "visible", // visible above the border
        // overflowY: "scroll" // visible above the border
    },
    tableContainer: {
        //        overflowX: "visible",
        //        overflowY: "scroll"
        /*
        overflowX: "hide",
        overflowY: "scroll"
        */

        // this is working +all the height down to the container have to be 100%, othervise
        // there is spilling over of the actual rows
        height: "100%",
        overflowX: "hidden",
        overflowY: "scroll",
    },

    tableCellStickyHeader: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: "sticky",
        backgroundColor: "#438CFF"
    },
    
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    headLabelRoot: {
        color: "white",
        fontSize: 19,

        // only this is working
        "&.MuiTableSortLabel-active": {
            color: theme.palette.common.white
        },

        '&:focus': {
            color: theme.palette.common.white
        },
        
        '&:hover': {
            color: grey[100],
            // fontSize: "15px", // stretches the whole thing
        },

        //        '& :active': {
        //            color: "white"
        //        }
    },
    
    tableRowRoot: {
        cursor: "pointer",
        '&:hover': {
            cursor: "pointer"
        },
    },

    headLabelIcon: {
        fontSize: 22,
        
        // this is possible, but does not work
        // '& svg': {
        //},
        
        '& path': {
            fill: theme.palette.common.white,
            // working, but don't need it
            //            '&:hover': {
            //                fill: red[100],
            //            },
        }
    },
    
    chartCell: {
        /*
        backgroundColor: "pink",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,

        '&:hover': {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        */
    },

    column1Value: {
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontWeight: 300,
        // fontSize: 17,
        fontSize: "14px",
        textAlign: "center",
        //        paddingRight: "0px",
        //        paddingLeft: "16px",
        // color: "#65676b"
        // color: "#4a4a4a",
        color: "#4a4a4ad1"
    },

    column1ValueLeft: {
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontWeight: 300,
        // fontSize: 17,
        fontSize: "14px",
        textAlign: "left",
        // paddingLeft: "30px",
        //        paddingRight: "0px",
        //        paddingLeft: "16px",
        // color: "#65676b"
        // color: "#4a4a4a",
        color: "#4a4a4ad1"
    },
    

    externalTooltip: {
        position: "absolute", // will be absolute to the "wrapper" and parallel to the sheet
        display: "none", // do not display at first
        //        top: "-12px",
        left: "0",
        padding: "0.6em 1em",
        background: "#fff",
        //   background: "red",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
        zIndex: 100
    },

    externalTooltipAnchor: {
        position: "absolute",
        width: "12px",
        height: "12px",
        bottom: "-0",
        left: "50%",
        transform: "translate(-50%, 50%) rotate(45deg)",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        // backgroundColor: "red",
        // transformOrigin: "center center", // we don't need this
    }
        
}));

export default function DashGen2Table(props) {

    const { dataset, header1, header2,
            align,
//            txtName,
            showPlace } = props
    
    log.trace("body: dataset =", dataset)
    
    const classes = useStyles()
    // eslint-disable-next-line
    const [order, setOrder] = React.useState('asc')
    // eslint-disable-next-line
    const [orderBy, setOrderBy] = React.useState('column2')
    const [selected, setSelected] = React.useState([])
    // eslint-disable-next-line
    const [page, setPage] = React.useState(0)
    // eslint-disable-next-line
    const [dense, setDense] = React.useState(true)
    const [rows, setRows] = React.useState([])
    // const [currentColumn1, setCurrentColumn1] = React.useState(null)

    //let rows = dataset

    /*
    if(dataset) {
        rows = dataset.map(d => {
            log.debug("map: setting up rows, d =",d)
            let column1
            let column1UUID
            if(d.column1 && d.column1.txt) {
                column1 = d.column1.val
                column1UUID = d.column1.uuid
            } else {
                column1 = "Loading..."
            }
            
            let column2
            if(d.column2 && d.column2.val) {
                column2 = d.column2.val
            } else {
                column2 = "Loading..."
            }

            return {
                column1: column1,
                column2: column2,
                item: {
                    uuid: column1UUID,
                    column1: {
                        uuid: "column1 uuid",
                        txt: "column1 txt"
                    },
                    statement: {
                        uuid: "statement uuid",
                        txt: "statement txt"
                    }
                },
            }
        })
            .reduce((rows, d) => { // make sure that we get 1 row per column1 only
                log.trace("reduce: rows =",rows)
                log.trace("reduce: d =",d)
                if(!rows.find(row => row.column1 === d.column1))
                    rows.push(d)
                return rows
            },[])
    }
    */

    log.trace("body: rows =",rows)

    // config, this 5 is config
    //    const [rowsPerPage, setRowsPerPage] = React.useState(100)
    const [rowsPerPage, setRowsPerPage] = React.useState(rows.length)

    /*
    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.column1.val);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    */

    const handleClick = (event, row) => {
        log.trace("handleClick(): event =", event)
        props.onRowClick(row, event) // we might need to see if it's double click here
    }
    
    // eslint-disable-next-line
    const handleClick_old = (event, column1) => {
        const selectedIndex = selected.indexOf(column1);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, column1);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    }

    /*
    // eslint-disable-next-line
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // eslint-disable-next-line
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = event => {
        setDense(event.target.checked);
    }
    */

    const handleMouseOver = row => event => {
        log.trace("handleMouseOver(): row =",row)
        log.trace("handleMouseOver(): props =", props)
        // setCurrentColumn1(row.column1)
        props.onRowHover(row) // call upper-level routine 
    }


    const handleMouseOut = row => event => {
        // TODO: only do mouseout if we "really" left the column1
        // and are not staying on the same row
        //log.trace("handleMouseOut(): row =",row)
        //log.trace("handleMouseOut(): props =", props)
        //log.trace("handleMouseOut(): currentColumn1 =", currentColumn1)
        //log.trace("handleMouseOut(): row.column1 =", row.column1)
        props.onRowUnhover(row) // call upper-level routine 
    }



    // const isSelected = column1 => selected.indexOf(column1) !== -1;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    
    React.useEffect(() => {
        if(dataset && dataset.length > 0) {
            setRows(dataset)
            setRowsPerPage(dataset.length) // I forgot to update this initially, spend 2 hours debugging :)
        } else {
        }
    }, [dataset])
    return (
        <div id="externalTooltipRoot" className={classes.root}>
          <div id="externalTooltip" className={classes.externalTooltip}>
            {/* <div id="name">name</div> */}
            <div id="col1">count</div>
            {/* TODO: this can be brought back later when we have the data fitured out*/}
            {/* <div id="states">states</div>*/}
            {/* <div id="uscds">uscds</div> */}
            <div className={classes.externalTooltipAnchor}></div>
          </div>
          <Paper className={classes.paper}>
            <EnhancedTableToolbar header1={header1} header2={header2} numSelected={selected.length} />
            <TableContainer className={classes.tableContainer}>
              <Table
                     stickyHeader
                     className={classes.table}
                     aria-labelledby="tableTitle"
                     size={dense ? 'small' : 'medium'}
                     aria-label="enhanced table">
                <TableBody classes={{}}>
                  {stableSort(rows, getSorting(order, orderBy))
                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                   .map((row,index) => {
                      const labelId = `enhanced-table-checkbox-${index}`
                      return (
                          <TableRow
                             hover
                             onClick={event => handleClick(event, row)}
                             role="checkbox"
                             tabIndex={-1}
                             key={row.column1.val}
                             onMouseOver={handleMouseOver(row)}
                             onMouseOut={handleMouseOut(row)}
                             classes={{
                                 root: classes.tableRowRoot
                             }}
                             style={{
                                 backgroundColor: row.column1.backgroundColor,
                             }}>
                             {showPlace &&
                              <TableCell padding="none"
                                         style={{
                                             textAlign: "center",
                                             fontSize: 17
                                         }}>
                                {index + 1}
                              </TableCell>
                             }
                             
                             <TableCell component="th" id={labelId} scope="row"
                                        padding={showPlace ? "none" : "default"}
                                        className={
                                            clsx(classes.column1Value, {
                                                [classes.column1ValueLeft]: align === "left"
                                            })
                                        }
                                        style={{
                                            color: row.column1.color,
                                            fontSize: row.column1.fontSize
                                        }}>
                               {row.column1.name &&
                                row.column1.name
                               }
                               
                               {!(row.column1.name && row.column1.val) &&
                                row.column1.val
                               }
                             </TableCell>
                           </TableRow>
                      )
                  })}
                  {emptyRows > 0 && (
                      <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                  )}
                </TableBody>
              </Table>
              </TableContainer>
          </Paper>
        </div>
    );
}
